import { render, staticRenderFns } from "./ReasonChose.vue?vue&type=template&id=920cd1c6&scoped=true&"
import script from "./ReasonChose.vue?vue&type=script&lang=js&"
export * from "./ReasonChose.vue?vue&type=script&lang=js&"
import style0 from "./ReasonChose.vue?vue&type=style&index=0&id=920cd1c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920cd1c6",
  null
  
)

export default component.exports